export const GET_BUSINESS_ACCOUNT = "GET_BUSINESS_ACCOUNT";
export const SHOW_BUSINESS_ACCOUNT = "SHOW_BUSINESS_ACCOUNT";
export const UPDATE_BUSINESS_ACCOUNT = "UPDATE_BUSINESS_ACCOUNT";
export const GET_BUSINESS_MEMBERS = "GET_BUSINESS_MEMBERS";
export const GET_BUSINESS_BANKS = "GET_BUSINESS_BANKS";
export const STORE_BUSINESS_ACCOUNT = "STORE_BUSINESS_ACCOUNT";